module.exports = __webpack_public_path__ + "static/media/03.a7446d7a.jpg";